import React, { Component } from 'react';
import { Toast } from 'primereact/toast';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';

import Server from '../Server.js'
import { connect } from "react-redux"
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import Header from '../Header.js'
import Num2persian from 'num2persian';
import { ProgressSpinner } from 'primereact/progressspinner';
import SignatureCanvas from 'react-signature-canvas'

class OfflineTransfer extends React.Component {
  constructor(props){
    super(props);  
    const { navigation } = this.props;
    this.Server = new Server();
    this.SendData = this.SendData.bind(this);  
    this.toast = React.createRef();
    
    this.state={      
      AccountNumber:window.location.href.split("account=")[1],
      Type:window.location.href.split("Type=")[1] && window.location.href.split("Type=")[1].split("&")[0],
      ShowLoading:false,
      Sheba:[],
      ShebaId:"",
      TransferAccount:"",
      AccPersonName:"",
      LocalAccKind:"",
      Amount:"",
      Desc:"",
      TransferId:"",
      SecCode:"",    
      TimeTransfer:"",
      ShebaBankName:"",
      ticketNo:null,
      ButtonText:"ارسال",
      IconName:"md-return-right",
      AfterSend:false,   
      AfterFinalSend:false,  
      Mnd:0,
      ResidNumber:null,
      SanadNumber:null,
      Subject:"",
      shareOptions:{}
    }
    this.GetAccounts()
  }

  onCancel() {
    console.log("CANCEL")
    this.setState({visible:false});
  }

  onOpen() {
    console.log("OPEN")
    this.setState({visible:true});
  }
  
  SendData(){  
    let that = this;
    let ip = that.props.ip || "https://ansar24.com";
    let ShebaId = that.state.ShebaId ? (that.state.ShebaId.split("ir")[1] || that.state.ShebaId.split("iR")[1] || that.state.ShebaId.split("Ir")[1] || that.state.ShebaId.split("IR")[1]) : "";
    let Amount = this.state.Amount ? parseInt(this.state.Amount.toString().replace(/,/g,"")) : 0;

    if(this.sigPad.toData().length == 0){
        that.toast.current.show({ severity: 'warn', summary: <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>, detail: <div className="iranyekanwebmedium">نمونه امضا را وارد کنید</div>, life: 4000 });
  
        return;
    }
    let sign = this.sigPad.getTrimmedCanvas()
    .toDataURL('image/png');

    if(!ShebaId){
      that.toast.current.show({ severity: 'warn', summary: <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>, detail: <div className="iranyekanwebmedium">کد شبا را وارد کنید</div>, life: 4000 });

      return;
    }
    if(ShebaId.length !=24){
      that.toast.current.show({ severity: 'warn', summary: <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>, detail: <div className="iranyekanwebmedium">تعداد ارقام کد شبا باید 24 باشد</div>, life: 4000 });

      return;
    }
    if(!Amount || Amount == NaN || Amount.toString().length < 4 ){
      that.toast.current.show({ severity: 'warn', summary: <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>, detail: <div className="iranyekanwebmedium">مبلغ را به درستی وارد کنید</div>, life: 4000 });
      return;
    }   
    if(Amount > this.state.Mnd){
      that.toast.current.show({ severity: 'warn', summary: <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>, detail: <div className="iranyekanwebmedium">مبلغ وارد شده از موجودی حساب بیشتر است</div>, life: 4000 });
      return;
    }   
    if(!that.state.AccPersonName){
      that.toast.current.show({ severity: 'warn', summary: <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>, detail: <div className="iranyekanwebmedium">نام صاحب حساب را وارد کنید</div>, life: 4000 });
      return;
    }   
    if(!that.state.AccBankName){
      that.toast.current.show({ severity: 'warn', summary: <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>, detail: <div className="iranyekanwebmedium">نام بانک را وارد کنید</div>, life: 4000 });
      return;
    } 
    let param = {
      AccountNumber:this.state.AccountNumber,
      Amount: Amount,
      AccBankName: this.state.AccBankName,
      AccPersonName: this.state.AccPersonName,
      desc: this.state.desc,
      ShebaId: this.state.ShebaId,
      sign: sign,
      status:0,
      username:this.props.username,
      mobile:this.props.mobile

    };
    this.setState({
      ShowLoading: 1
    })
    let SCallBack = function (response) {
      
      that.setState({
        ShowLoading: 0
      })
      that.toast.current.show({ severity: 'success', summary: <div className="iranyekanwebmedium">عملیات موفق</div>, detail: <div className="iranyekanwebmedium">درخواست شما ثبت شد</div>, life: 4000 });
    };
    let ECallBack = function (error) {
      that.setState({
        ShowLoading: 0
      })
    }
    this.Server.send("AdminApi/setTransferReq", param, SCallBack, ECallBack)             
    
  }
  GetAccounts(RefreshVam){
    let that = this;
    let Mnd=0;
    let SCallBack = function(response){
      let data=null;
      let resp=[];
     for(let i=0;i<response.length;i++){
       resp[i] = response[i].children;
      
     }
     for(let i=0;i<resp.length;i++){
      for(let j=0;j<resp[i].length;j++){
        if(resp[i][j].name=="A_Accx" && resp[i][j].value == that.state.AccountNumber){
            data = resp[i]
            break;
        }
      }   
     }
     for(let i=0;i<data.length;i++){
        if(data[i].name=="A_Mnd"){
          Mnd = data[i].value
        }
     }
    
     
     
     that.setState({
      Mnd:Mnd,
      ShowLoading:0
     })  
     that.GetInitialData();
    
    } 
    let ECallBack = function(error){
      that.setState({
        ShowLoading:0
      })
    }
    
    var param = '{CommandNo : "3" , AccountNo: "' + that.props.account + '",Param1: "' + that.props.password + '" }';
    let ip = that.props.ip || "https://ansar24.com";

    that.Server.sendRaymand(""+ip+"/MobileBank.aspx/MobileBankSp",param,SCallBack,ECallBack,{
      ip: that.props.ip
  })
  }
  GetInitialData(){
   
    let that = this;
    let SCallBack = function(response){
      that.setState({
        ShowLoading:false
      })
      let resp=[];
     for(let i=0;i<response.length;i++){
       resp[i] = response[i].children;
      
     }
     let Sheba = [],
         ShebaVal=[]; 

     for(let i=0;i<resp.length;i++){
        let Sh = {},
        BankName="",  
        shebaCode="",
        PersonName="";
        for(let j=0;j<resp[i].length;j++){

          if(resp[i][j] && resp[i][j].name=="Sheba"){
            ShebaVal.push(resp[i][j].value)
            shebaCode = resp[i][j].value;
          }
          if(resp[i][j] && resp[i][j].name=="BankName"){
            BankName=resp[i][j].value;
          }
          if(resp[i][j] && resp[i][j].name=="ShebaName"){   
            PersonName=resp[i][j].value;
          }
         
          

         
        }
        Sh = {"value":shebaCode,"label":PersonName + "," +  BankName}
        Sheba.push(Sh);

     }
     that.setState({
        Sheba:Sheba
     })
     if(Sheba.length == 0)
      return;
    
      
     
        
     
    } 
    let ECallBack = function(error){
      that.setState({
        ShowLoading:false
      })  
    }
    var param = '{CommandNo : "70" , AccountNo: "' + that.state.AccountNumber + '",Param1: "' + that.props.username + '" }';
    let ip = that.props.ip || "https://ansar24.com";

    this.setState({
      ShowLoading:true
    }) 
    that.Server.sendRaymand(""+ip+"/MobileBank.aspx/MobileBankSp",param,SCallBack,ECallBack,{
      ip: that.props.ip
  })
  }

  getTransferReq(){
    let that = this;
    let param = {
      username:this.props.username
    };
    this.setState({
      ShowLoading: 1
    })
    let SCallBack = function (response) {
      that.setState({
        ShowLoading: 0,
        Gardesh:response.data.result
      })
    };
    let ECallBack = function (error) {
      that.setState({
        ShowLoading: 0
      })
    }
    this.Server.send("AdminApi/getTransferReq", param, SCallBack, ECallBack)
  }
 
  render() {      
   
    
 
 
    return (       
      <div style={{height:'100%'}}>
                <Toast ref={this.toast} position="top-right" style={{ fontFamily: 'iranyekanwebmedium', textAlign: 'right' }} />

      <div>
      <Header credit={this.state.credit} ComponentName="انتقال وجه" />

    </div>
    {!this.state.ShowLoading ?
      <div style={{direction:'rtl',padding:20,backgroundColor: '#fff',height:'100%'}}>
        <Button className="IRANYekan p-button-warning" style={{float:'left',padding:5,textAlign:'center'}}   onClick={()=>{
          this.setState({VisibleDialog:true})
          this.getTransferReq();  
        }}>
            <span style={{fontFamily:'iranyekanwebmedium',fontSize:15 }}>پیگیری درخواست های قبلی</span> 
          </Button>
            <p  className="iranyekanwebmedium" style={{clear:'both'}} > حساب {this.state.AccountNumber}</p>
            <p  className="iranyekanwebmedium" > موجودی : {this.state.Mnd.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ریال</p>

           {!this.state.AfterFinalSend &&
           <div> 
           <div>
          {!this.state.AfterSend && this.state.Sheba.length>0 && 
          <Dropdown value={this.state.ShebaTemp} className="iranyekanwebmedium" style={{width:'100%'}} options={this.state.Sheba} onChange={(e) => {
            this.setState({
              ShebaId:e.value,
              ShebaTemp:e.value
            })
            
          }} placeholder="کد شبا را انتخاب کنید"/>

          }
          <div floatingLabel style={{marginTop:15}}>       
          <div className="iranyekanwebmedium" >حساب شبا مقصد</div>
            <InputText autocomplete="off" value={this.state.ShebaId}  keyboardType="number-pad" name="ShebaId" onChange={(text) => this.setState({ShebaId:text.target.value})  } placeholder="IR000000000000000000000000"  style={{textAlign:"left",fontFamily:'iranyekanwebmedium',width:'100%'}}  />
          </div>   
          <div floatingLabel style={{marginTop:10}}>           
          <div className="iranyekanwebmedium" >نام صاحب حساب مقصد</div>
            <InputText autocomplete="off" value={this.state.AccPersonName}  keyboardType="default" name="AccPersonName" onChange={(text) => this.setState({AccPersonName:text.target.value})  }  style={{textAlign:"center",fontFamily:'iranyekanwebmedium',width:'100%'}}  />
          </div>
          <div floatingLabel style={{marginTop:10}}>           
          <div className="iranyekanwebmedium" >نام بانک</div>
            <InputText autocomplete="off" value={this.state.AccBankName}  keyboardType="default" name="AccBankName" onChange={(text) => this.setState({AccBankName:text.target.value})  }  style={{textAlign:"center",fontFamily:'iranyekanwebmedium',width:'100%'}}  />
          </div>
          
          
          </div>        
             
          <div floatingLabel> 
          <div style={{fontFamily:'iranyekanwebmedium'}} >مبلغ</div>
            <InputText autocomplete="off" value={this.state.Amount}  keyboardType="number-pad" name="Amount" onChange={(text) => {let txt=text.target.value.replace(/,/g,""); this.setState({Amount:txt.replace(/\B(?=(\d{3})+(?!\d))/g, ",")})  }}  style={{textAlign:"center",fontFamily:'iranyekanwebmedium',width:'100%'}}  />
            {this.state.Amount &&
              <div style={{fontFamily:'iranyekanwebmedium',marginTop:7,marginBottom:7}}>{Num2persian(this.state.Amount.toString().replace(/,/g,""))} {this.state.Amount != "" ? <span style={{color:'red',textAlign:'left',fontFamily:'iranyekanwebmedium',fontSize:11,paddingRight:5 }}>ریال</span>  : ""} </div>
            }
            </div>
         
          <div floatingLabel>                          
          <div style={{fontFamily:'iranyekanwebmedium'}} >شرح</div>
            <InputText autocomplete="off" value={this.state.Desc} keyboardType="default" name="Desc" onChange={(text) => this.setState({Desc:text.target.value})  }  style={{textAlign:"center",fontFamily:'iranyekanwebmedium',width:'100%'}}  />
          </div>
          <div floatingLabel style={{marginTop:15,border:'1px solid red',position:'relative',padding:5}}>       
          <div className="iranyekanwebmedium"  >نمونه امضا</div>
            <SignatureCanvas penColor='green' 
              canvasProps={{width: 500, height: 200, className: 'sigCanvas'}} ref={(ref) => { this.sigPad = ref }} />
              <Button block info rounded style={{marginTop:10,marginLeft:10,marginRight:10,marginBottom:10,position:'absolute',top:0,left:0}}  onClick={()=>{this.sigPad.clear()}}>
            <span style={{fontFamily:'iranyekanwebmedium',fontSize:15 }}>پاک کردن</span> 
           </Button>  
          </div> 
          <div className="col-12" style={{ textAlign: 'right', display: 'flex', alignItems: 'center', padding: 0, marginRight: 5, direction: 'rtl',marginTop:15 }}>
                  <Checkbox inputId="verify" value={this.state.verify} checked={this.state.verify} onChange={e => this.setState({ verify: e.checked })}></Checkbox>
                  <label htmlFor="verify" className="p-checkbox-label IRANYekan" style={{ paddingRight: 5,fontSize:12 }}> اینجانب  {this.props.fullname}  صاحب امضا فوق مسئولیت درخواست انتقال وجه جاری را به عهده میگیرم</label>
          </div>

          <Button block info rounded style={{marginTop:10,marginLeft:10,marginRight:10,marginBottom:10,padding:10,borderRadius:8}} disabled={!this.state.verify||this.state.ShowLoading}  onClick={this.SendData}>
            <span style={{fontFamily:'iranyekanwebmedium',fontSize:15 }}>{this.state.ButtonText}</span> 
            <i name={this.state.IconName} style={{fontSize:18,color:'#000'}} />        
          </Button>  
          
          </div>
          }   
          
          {this.state.AfterFinalSend&&
          <div><div style={{textAlign:'center',marginTop:100}}>
              <div><span style={{fontFamily:'iranyekanwebmedium',fontSize:15,color:'green'}} >انتقال وجه با موفقیت انجام شد</span></div>  
              <div><span style={{fontFamily:'iranyekanwebmedium',fontSize:18,color:'blue',marginTop:30}} >رسید تراکنش</span></div>  
              <div><span style={{fontFamily:'iranyekanwebmedium',fontSize:15,marginTop:30}} >نام صاحب حساب مقصد : {this.state.AccPersonName}</span></div>  
              {this.state.Type=="LocalTransfer" ?
              <div><span style={{fontFamily:'iranyekanwebmedium',fontSize:15,marginTop:15}}>مبلغ : {this.state.Amount} ریال</span></div>  
              :
              <div><span style={{fontFamily:'iranyekanwebmedium',fontSize:15,marginTop:15}}>مبلغ : {(parseInt(this.state.Amount.toString().replace(/,/g,""))+25000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ریال</span></div>  
              }
              <div><span style={{fontFamily:'iranyekanwebmedium',fontSize:15,marginTop:15}}>رسید : {this.state.ResidNumber}</span></div> 
              <div><span style={{fontFamily:'iranyekanwebmedium',fontSize:15,marginTop:15}}>شماره ثبت سند :{this.state.SanadNumber}</span></div>  
          </div>     
           
           </div>
          }
       <Dialog visible={this.state.VisibleDialog} onHide={()=>{this.setState({VisibleDialog:false})}}  maximized={true}>
       <div>
         <p style={{textAlign:'center',fontFamily:'iranyekanwebmedium',fontSize:18}} > آرشیو درخواست های انتقال وجه </p>
        <div style={{display:'flex',flexDirection:'row-reverse',justifyContent:'space-between',alignItems:'center',marginTop:10,backgroundColor:'#cdd8df'}}>
               
                <div style={{width:'25%',textAlign:'center'}}> 
                  <span style={{textAlign:'center',fontFamily:'iranyekanwebmedium',fontSize:11}}>مبلغ</span>
                </div>
                <div style={{width:'30%',textAlign:'center'}}> 
                  <span style={{textAlign:'center',fontFamily:'iranyekanwebmedium',fontSize:11}}>صاحب حساب </span>
                </div>
                
                <div style={{width:'20%',textAlign:'center'}}> 
                  <span style={{textAlign:'center',fontFamily:'iranyekanwebmedium',fontSize:11}}>تاریخ</span>
                </div>
                <div style={{width:'25%',textAlign:'center'}}> 
                  <span style={{textAlign:'center',fontFamily:'iranyekanwebmedium',fontSize:11}}>وضعیت</span>
                </div>
               
                
          </div>    
          {this.state.Gardesh && this.state.Gardesh.length > 0 && this.state.Gardesh.map((v,i) => {
            return(
              <div style={{display:'flex',flexDirection:'row-reverse',justifyContent:'space-between',alignItems:'center',backgroundColor: (i % 2 == 0) ? '#fff' : '#eee' }}>
                
                <div style={{width:'25%',textAlign:'center'}}> 
                  <span style={{textAlign:'center',fontFamily:'iranyekanwebmedium',fontSize:11}}>{v.Amount ? v.Amount.toString().replace(",","").replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0}</span>
                </div>
                <div style={{width:'30%',textAlign:'center'}}> 
                <span style={{textAlign:'center',fontFamily:'iranyekanwebmedium',fontSize:11}} >{v.AccPersonName}</span>
                </div>
                
                <div style={{width:'20%',textAlign:'center'}}> 
                  <div style={{textAlign:'center',fontFamily:'iranyekanwebmedium',fontSize:11}}>
                  {v.ReqDate}
                  </div>
                  <div style={{textAlign:'center',fontFamily:'iranyekanwebmedium',fontSize:11}}>
                  {v.ReqTime}
                  </div>
                  

                </div>
                <div style={{width:'25%',textAlign:'center'}}> 
                {v.status == 0 &&
                  <span style={{textAlign:'center',fontFamily:'iranyekanwebmedium',fontSize:12,color:'gray'}}>در حال بررسی</span>
                }
                {v.status == 1 &&
                  <span style={{textAlign:'center',fontFamily:'iranyekanwebmedium',fontSize:12,color:'green'}}>تایید شده</span>
                }
                {v.status == -1 &&
                  <span style={{textAlign:'center',fontFamily:'iranyekanwebmedium',fontSize:12,color:'red'}}>رد شده</span>
                }
                </div>
              </div>       
            )
            })
          }
          </div>
       </Dialog>
    </div>
    :
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',height:'100%' }}>
      <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="2" fill="var(--surface-ground)" animationDuration=".5s" />
    </div>
    }
    </div> 
    );
  }
}

function mapStateToProps(state) {        
  return {
    username : state.username,
    password : state.password,
    ip : state.ip,
    account:state.account,
    place:state.place,
    fullname : state.fullname,
    tokenrb: state.tokenrb,
    mobile : state.mobile,
    appData:state.appData,
    creditPrice:state.creditPrice,
    systemId:state.systemId
  }
}
export default connect(mapStateToProps)(OfflineTransfer)  
